(() => {
  const carouselSelector = '[data-hol-subcollection-carousel]';

  function initialiseCarousel(carousel) {
    if (carousel.dataset.holCarouselReady === 'true') return;

    const track = carousel.querySelector('[data-hol-carousel-track]');
    const previousButton = carousel.querySelector('[data-hol-carousel-previous]');
    const nextButton = carousel.querySelector('[data-hol-carousel-next]');
    const firstCard = track?.querySelector('.hol-neon-collection__card');

    if (!track || !previousButton || !nextButton || !firstCard) return;

    carousel.dataset.holCarouselReady = 'true';
    let frameRequest;

    const getScrollStep = () => {
      const trackStyles = window.getComputedStyle(track);
      const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    };

    const updateControls = () => {
      const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const isScrollable = maximumScroll > 1;

      carousel.classList.toggle('is-scrollable', isScrollable);
      previousButton.disabled = !isScrollable || track.scrollLeft <= 1;
      nextButton.disabled = !isScrollable || track.scrollLeft >= maximumScroll - 1;
    };

    const queueControlUpdate = () => {
      window.cancelAnimationFrame(frameRequest);
      frameRequest = window.requestAnimationFrame(updateControls);
    };

    const move = (direction) => {
      track.scrollBy({ left: getScrollStep() * direction, behavior: 'smooth' });
    };

    previousButton.addEventListener('click', () => move(-1));
    nextButton.addEventListener('click', () => move(1));
    track.addEventListener('scroll', queueControlUpdate, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1);
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(queueControlUpdate).observe(track);
    } else {
      window.addEventListener('resize', queueControlUpdate, { passive: true });
    }

    updateControls();
  }

  function initialiseCarousels(root = document) {
    root.querySelectorAll(carouselSelector).forEach(initialiseCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseCarousels());
  } else {
    initialiseCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseCarousels(event.target));
})();
